import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 全局less
import './assets/style/global.less';

// 阿里图标
import './assets/fonts/iconfont.css';
import './assets/fonts/iconfont';

//引入element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
// 引入vant
import './common/_vant'
import 'vant/lib/index.css';

// 轮播
import VueSuperSlide from 'vue-superslide'
Vue.use(VueSuperSlide)


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
